import { render, staticRenderFns } from "./scontrol.vue?vue&type=template&id=66a6d822"
import script from "./scontrol.vue?vue&type=script&lang=js"
export * from "./scontrol.vue?vue&type=script&lang=js"
import style0 from "./scontrol.vue?vue&type=style&index=0&id=66a6d822&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports